import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Breadcrumb } from "antd";
import * as actions from './redux/actions';

export class ChapterHeader extends Component {
  static propTypes = {
    quesStore: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    const { fetchQuesCreateChapterSuccess } = this.props.quesStore;
    if (!fetchQuesCreateChapterSuccess) return null;
    const { ChapterName, list } = fetchQuesCreateChapterSuccess;
    const { ExamModel } = this.props;
    let doneCount = 0;
    list.forEach(item => {
      if (item.MyAnswer) {
        doneCount++;
      }
    })
    return (
      <div className="ques-store-chapter-header">
        <h1>
          <Breadcrumb separator=">">
            <Breadcrumb.Item href="/center/startExer/0">开始做题</Breadcrumb.Item>
            <Breadcrumb.Item>章节练习</Breadcrumb.Item>
            <Breadcrumb.Item>{ExamModel === 0 ? "练习模式" : "考试模式"}</Breadcrumb.Item>
            <Breadcrumb.Item>{ChapterName}</Breadcrumb.Item>
          </Breadcrumb>
        </h1>
        <div className="progress">
          <h2>
            <p className="progress-bar" style={{ width: `${(doneCount / list.length) * 100}%` }}></p>
          </h2>
          <p className="progress-info">
            <span>已完成{doneCount}题</span><span>/共{list.length}题</span>
          </p>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    quesStore: state.quesStore,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChapterHeader);



// WEBPACK FOOTER //
// ./src/features/ques-store/ChapterHeader.js